module.exports = __webpack_public_path__ + "@/assets/img/silver.dfcbb552.jpeg";